<template>
  <div>
    <div class="row">
      <div class="col">
        <h3>Record Holder Type
          <help-tooltip mode="danger" v-if="selectedObjectModel.publishedRecord && (selectedObjectModel.holder_type != selectedObjectModel.publishedRecord.holder_type)">Selection differs from published selection. The change will make all previous records invalid.</help-tooltip>
        </h3>
        
        <fieldset>
          <div class="radio-inline">
            <input
              type="radio"
              name="holder-type"
              id="individual-holder"
              v-model="selectedObjectModel.holder_type"
              :value="ObjectModelRecordHolderType.Individual"
            />
            <label for="individual-holder">Individual</label>
          </div>
          <div class="radio-inline">
            <input
              type="radio"
              name="holder-type"
              id="entity-holder"
              v-model="selectedObjectModel.holder_type"
              :value="ObjectModelRecordHolderType.Entity"
            />
            <label for="entity-holder">Entity</label>
          </div>
          <div class="radio-inline">
            <input
              type="radio"
              name="holder-type"
              id="no-holder"
              v-model="selectedObjectModel.holder_type"
              :value="ObjectModelRecordHolderType.None"
            />
            <label for="no-holder">No Record Holder</label>
          </div>
            
        </fieldset>
        <hr />
      </div>
    </div>
    <div class="row mb-3">
      <div class="col">
        <h3>My Licenses, Permits & Registrations</h3>
        <p>
          Do you want this object to show on the dashboard?
          <help-tooltip>If you select "No", when a record is created on behalf of an individual or entity by a Formability Admin, then neither the individual nor entity will be notified of or invited to claim the new record, and the record will not appear on the invdividual's or entity's dashboard.</help-tooltip>
        </p>
        <yes-no-radio
          id="dashboard-display-enabled"
          v-model="selectedObjectModel.dashboard_display_enabled"
        ></yes-no-radio>
      </div>
    </div>

    <div v-if="selectedObjectModel.dashboard_display_enabled">
      <row class="mb-3">
        <column>
          <view-settings-dashboard-account-relation-selection/>
        </column>
      </row>

      <row>
        <column>
          <label for="dashboard_name">Name</label>
        </column>
      </row>
      <row class="component-row">
        <column>
          <config-field-validation :model="selectedObjectModel" field-name="dashboard_name">
            <input
              type="text"
              id="dashboard_name"
              placeholder="Enter Name"
              v-model="selectedObjectModel.dashboard_name"
            />
          </config-field-validation>
        </column>

        <column size="50" class="align-center">
          <strong>Or</strong>
        </column>
        <column>
          <a-select
            v-model="selectedObjectModel.dashboard_name_property_client_id"
            :options="propertySelectOptions([ObjectModelPropertyRootType.Text, ObjectModelPropertyRootType.PickList])"
            placeholder="Select Property Type"
          ></a-select>
        </column>
      </row>
      <row>
        <column>
          <config-field-validation
            :model="selectedObjectModel"
            field-name="dashboard_number_property_client_id"
          >
            <label for="dashboard_number_property_client_id" class="a-select-label">Number</label>
            <a-select
              v-model="selectedObjectModel.dashboard_number_property_client_id"
              :options="numberPropertySelectOptions"
              id="dashboard_number_property_client_id"
              placeholder="Select Property Type"
            ></a-select>
          </config-field-validation>
        </column>
        <column size="50" />
        <column>
          <config-field-validation
            :model="selectedObjectModel"
            field-name="dashboard_expiration_property_client_id"
          >
            <label
              for="dashboard_expiration_property_client_id"
              class="a-select-label"
            >Expiration Date</label>
            <a-select
              v-model="selectedObjectModel.dashboard_expiration_property_client_id"
              :options="propertySelectOptions([ObjectModelPropertyRootType.DateTime, ObjectModelPropertyRootType.DerivedField])"
              id="dashboard_expiration_property_client_id"
              placeholder="Select Property Type"
            ></a-select>
          </config-field-validation>
        </column>
      </row>
      <row>
        <column>
          <config-field-validation
            :model="selectedObjectModel"
            field-name="dashboard_status_property_client_id"
          >
            <label for="dashboard_status_property_client_id" class="a-select-label">Status</label>
            <a-select
              v-model="selectedObjectModel.dashboard_status_property_client_id"
              :options="propertySelectOptions([ObjectModelPropertyRootType.PickList])"
              id="dashboard_status_property_client_id"
              placeholder="Select Property Type"
            ></a-select>
          </config-field-validation>
        </column>
        <column size="50" />
        <column v-if="!selectedObjectModel.dashboard_linked_detail_view_rule_enabled">
          <label for="dashboard_linked_detail_view_id" class="a-select-label">Associated Detail View</label>
          <a-select
            v-model="linkedDetailView"
            :options="linkedDetailViewOptions"
            bind-by-object
            id="dashboard_linked_detail_view_id"
            placeholder="Search Detail View"
          ></a-select>
        </column>
      </row>

      <row>
        <column>
          <label>Does the Detail View change based upon a property?</label>
          <yes-no-radio
            @input="selectConditionalLinkedDetailViews"
            id="dashboard_linked_detail_view_rule_enabled"
            v-model="selectedObjectModel.dashboard_linked_detail_view_rule_enabled"
          ></yes-no-radio>
        </column>
      </row>

      <hr />

      <template v-if="selectedObjectModel.dashboard_linked_detail_view_rule_enabled">
        <div
          v-for="(dashboardConditionalLinkedDetailView, key, index) in selectedObjectModel.dashboard_conditional_linked_detail_views"
          :key="key"
          :id="`dashboard-conditional-linked-detail-view-${index}`"
          class="em-block"
        >
          <div class="em-child">
            <row>
              <column>
                <label
                  :id="`dashboard_conditional_linked_detail_view_conditional_rule_sets_${index}`"
                >Add Rule</label>
              </column>
              <div class="col text-right" v-if="index > 0">
                <button
                  class="btn-icon grey-to-red close"
                  @click="deleteDashboardConditionalLinkedDetailView(dashboardConditionalLinkedDetailView)"
                >
                  <icon class="times"></icon>
                  <span class="sr-only">Delete</span>
                </button>
              </div>
            </row>
            <row class="m-2">
              <column>
                <div class="rule-set">
                  <div class="col">
                    <edit-conditional-rule-set
                      v-if="ruleSets(dashboardConditionalLinkedDetailView).length > 0"
                      :parent="dashboardConditionalLinkedDetailView"
                      :ruleSet="ruleSets(dashboardConditionalLinkedDetailView)[0]"
                      outside-modal
                    ></edit-conditional-rule-set>
                  </div>
                </div>
              </column>
            </row>
            <row>
              <column>
                <label
                  :for="`conditional_linked_detail_view_id_${index}`"
                  class="a-select-label"
                >Display</label>
                <a-select
                  v-model="dashboardConditionalLinkedDetailView.conditional_linked_detail_view_id"
                  :options="conditionalLinkedDetailViewOptions(dashboardConditionalLinkedDetailView.conditional_linked_detail_view)"
                  :id="`conditional_linked_detail_view_id_${index}`"
                  placeholder="Search Detail View"
                ></a-select>
              </column>
            </row>
          </div>
        </div>
        <row>
          <column>
            <div class="cta">
              <button
                class="btn grey-to-blue"
                @click="addDashboardConditionalLinkedDetailView"
              >+ Add Detail View Condition</button>
            </div>
          </column>
        </row>
        <row>
          <column>
            <label for="fallback-detail-view-finder" class="a-select-label">Otherwise Display</label>
            <a-select
              v-model="selectedObjectModel.dashboard_conditional_fallback_linked_detail_view_id"
              :options="conditionalLinkedDetailViewOptions(selectedObjectModel.dashboard_conditional_fallback_linked_detail_view)"
              id="fallback-detail-view-finder"
              placeholder="Search Detail View"
            ></a-select>
          </column>
        </row>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import selectedMixin from "../mixins/selectedMixin";
import YesNoRadio from "~/components/yes-no-radio.vue";
import { ObjectModelPropertyRootType } from "~/enums/objectModelPropertyType";
import { ObjectModelRecordHolderType } from "~/enums/objectModelRecordHolderType";
import { IDefaultVOption, IVOptionSetEndpoint, IVOptionSetLocal } from "~/interfaces/vSelectInterfaces";
import { InputFormatType } from "../../form_builder/models/inputFormatType";
import ObjectModelAssociationConditionalRuleBuilder from "~/components/conditionalRuleBuilder/object-model-association-conditional-rule-builder.vue";
import { ConditionalFieldDefinition } from "~/models/conditionalRules/conditionalFieldDefinition";
import ObjectModelConditionalFields from "~/models/objectModels/objectModelConditionalFields";
import EditConditionalRuleSet from "~/components/conditionalRuleBuilder/editConditionalRuleSet.vue";
import ConfigFieldValidation from "~/components/modelProperties/config-field-validation.vue";
import ObjectModel from "~/models/objectModel";
import ObjectModelProperty from "~/models/objectModelProperties/objectModelProperty";
import propertySelectOptionsMixin from "~/mixins/modelProperties/propertySelectOptionsMixin";
import ViewSettingsDashboardAccountRelationSelection from './view-settings-dashboard-account-relation-selection.vue'


export default Vue.extend({
  mixins: [selectedMixin, propertySelectOptionsMixin],
  components: {
    YesNoRadio,
    ObjectModelAssociationConditionalRuleBuilder,
    EditConditionalRuleSet,
    ConfigFieldValidation,
    ViewSettingsDashboardAccountRelationSelection
  },
  data: function() {
    return {
      ObjectModelPropertyRootType,
      ObjectModelRecordHolderType,
      selectedObjectModelAssociation: null
    };
  },
  computed: {
    linkedDetailView: {
      get(): { id: string; title: string } | null {
        if (!this.selectedObjectModel.dashboard_linked_detail_view_id) return null;
        return {
          id: this.selectedObjectModel.dashboard_linked_detail_view_id,
          title: this.selectedObjectModel.dashboard_linked_detail_view_title
        };
      },
      set({ id, title }: { id: string; title: string }) {
        this.selectedObjectModel.dashboard_linked_detail_view_id = id;
        this.selectedObjectModel.dashboard_linked_detail_view_title = title;
      }
    },
    linkedDetailViewOptions(): IVOptionSetEndpoint {
      return {
        endpoint: `/object_models/${this.selectedObjectModel.id}/search_detail_views`,
        rootKey: "detail_views",
        valueKey: "id",
        labelKey: "title",
        selectedOption: this.linkedDetailView
      };
    },
    numberPropertySelectOptions(): IDefaultVOption[] {
      return this.propertySelectOptions(prop => {
        if (prop.property_type === ObjectModelPropertyRootType.Number) {
          return prop.format_type === InputFormatType.Numeric;
        } else {
          return (
            prop.property_type === ObjectModelPropertyRootType.AutoIncrement ||
            prop.property_type === ObjectModelPropertyRootType.DerivedField ||
            prop.property_type === ObjectModelPropertyRootType.Text
          );
        }
      });
    },
    fieldDefinition(): ConditionalFieldDefinition {
      return ObjectModelConditionalFields.DASHBOARD_CONDITIONAL_LINKED_DETAIL_VIEW;
    },
  },
  methods: {
    propertySelectOptions(filter: ((ObjectModelPropertyRootType) => boolean) | ObjectModelPropertyRootType[]): IVOptionSetLocal[] {
      return this.propertySelectOptionSets(this.selectedObjectModel, false, filter, 'client_id');
    },
    ruleSets(dashboardConditionalLinkedDetailView) {
      return dashboardConditionalLinkedDetailView.getSortedConditionalRuleSets(this.fieldDefinition.fieldName);
    },
    addDashboardConditionalLinkedDetailView(): void {
      this.selectedObjectModel.createDashboardConditionalLinkedDetailView(this.selectedObjectModel);
    },
    conditionalLinkedDetailViewOptions(detailView): IVOptionSetLocal {
      return {
        valueKey: "id",
        labelKey: "title",
        heading: "Detail Views",
        options: this.selectedObjectModel.detail_views,
        selectedOption: detailView
      };
    },
    deleteDashboardConditionalLinkedDetailView(dashboardConditionalLinkedDetailView) {
      dashboardConditionalLinkedDetailView.destroy();
    },
    selectConditionalLinkedDetailViews(conditionalDetailViewsEnabled) {
      if (
        conditionalDetailViewsEnabled &&
        Object.keys(this.selectedObjectModel.dashboard_conditional_linked_detail_views).length === 0
      ) {
        this.selectedObjectModel.createDashboardConditionalLinkedDetailView(this.selectedObjectModel);
      }
    }
  }
});
</script>